import { Domains } from '@visikon/core-models/i18n/languages';

export const BATCH_DOMAINS = Domains.flatMap((domain) => domain.sites);
